export const calcMessagePosition = (cat: HTMLDivElement) => {
  const x = cat.getBoundingClientRect().right;
  const y = cat.getBoundingClientRect().top;
  return [x, y];
}